import React, { Component } from "react";
import { List, Icon, Checkbox, Button } from "semantic-ui-react";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  iconAndName: {
    display: "flex",
    alignItems: "center"
  },
  nameAndInfo: {
    display: "flex",
    flexDirection: "column"
  },
  info: {
    color: "rgba(0,0,0,.4)"
  }
};

class PractitionerItem extends Component {
  state = {
    checked: false
  };

  componentDidMount() {
    this.setState({
      checked: this.props.practitioner.approved === 1 ? true : false
    });
  }

  render() {
    return (
      <List.Item className="listItemPadding">
        <List.Content verticalAlign="middle">
          <div style={styles.listItem}>
            <div style={styles.iconAndName}>
              <Icon size="big" color="teal" name="user md" />
              <div style={styles.nameAndInfo}>
                <a
                  onClick={() => {
                    this.props.selectedPractitioner(this.props.practitioner);
                    this.props.showEditForm();
                  }}
                >
                  {this.props.practitioner.names +
                    " " +
                    this.props.practitioner.lastnames}
                </a>
                <span style={styles.info}>
                  ID: {this.props.practitioner.practitioner_id}
                </span>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <Checkbox
                className="alignEnable"
                toggle
                name={this.props.practitioner.practitioner_id}
                onChange={this.props.onChangeCheckbox}
                checked={this.props.practitioner.approved === 1 ? true : false}
                floated="right"
              />
              <Button
                className="alignDelete"
                icon="trash"
                color="red"
                onClick={() =>
                  this.props.deletePractitioner(this.props.practitioner.id)
                }
              ></Button>
            </div>
          </div>
        </List.Content>
      </List.Item>
    );
  }
}

export default PractitionerItem;
